module.exports = __webpack_public_path__ + "public/img/13.0798e9b2.png";